import "./../../../../lib/Litepicker/dist/litepicker.js";
import { DateTime } from "litepicker/dist/types/datetime";
import "litepicker/dist/plugins/mobilefriendly";
import "litepicker/dist/plugins/ranges";
import { createLoader } from "../../../../assets/js/helpers";
import { BookingDetails } from "./BookingDetails";
import { BookingAjaxes } from "./BookingAjaxes";
import Cart from "./Cart";
import CalendarSettings from "./CalendarSettings";
import CalendarUtils from "../../../calendar/CalendarUtils";
import * as dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

export interface IOptions {
  container: NodeListOf<HTMLElement>;
  language?: string;
}

export class BookingCalendar {
  BookingDetails: BookingDetails;
  Cart: Cart;
  options: IOptions;

  constructor(options: IOptions) {
    this.options = { ...options };
    this.BookingDetails = new BookingDetails({
      container: document.querySelector(".booking-details") as HTMLElement,
    });
    this.Cart = new Cart();
    this.setDefaultSettings();
  }

  appendCalendar() {
    const { container, language } = this.options;

    if (container.length) {
      const bookingAjaxes = new BookingAjaxes();

      container.forEach((singleContainer) => {
        const bookingContainer = singleContainer.closest(".booking-container");
        const loader = createLoader(bookingContainer as HTMLElement);

        if (bookingContainer) {
          Promise.all([
            bookingAjaxes.getBookedDays(),
            this.Cart.getCartFragment(),
            bookingAjaxes.getDisabledDays(),
            bookingAjaxes.getBookingDays(),
          ]).then(
            ([booked, cartFragment, disbaledDatesResponse, bookingDates]) => {
              const disableDates = disbaledDatesResponse.dates;
              const BookningDates = bookingDates.dates;
              const bookeddates = booked.dates;
              this.appendCartFragment(cartFragment.data.view);
              bookingContainer.classList.add("is-active");
              loader?.remove();

              const { dateStart, dateEnd } = cartFragment.data;

              if (dateStart && dateEnd) {
                this.BookingDetails.setActiveButtons();
              }

              var blockthisshit = Object.assign(bookeddates, BookningDates);

              const blockthisshit2 = [];
              for (const sezon of Object.values(disableDates)) {
                for (const value of Object.values(blockthisshit)) {
                  if (
                    // @ts-expect-error
                    (new Date(value[0]).getTime() <=
                      new Date(sezon[0]).getTime() &&
                      new Date(sezon[0]).getTime() <=
                        new Date(value[1]).getTime()) ||
                    // @ts-expect-error
                    (new Date(value[0]).getTime() <=
                      new Date(sezon[1]).getTime() &&
                      new Date(sezon[1]).getTime() <=
                        new Date(value[1]).getTime())
                  ) {
                    if (
                      blockthisshit2.filter(
                        (e) => e?.[0] === sezon[0] && e?.[1] === sezon[1]
                      ).length == 0
                    ) {
                      blockthisshit2.push([sezon[0], sezon[1]]);
                    }
                  }
                }
              }

              blockthisshit = blockthisshit.concat(blockthisshit2);
              blockthisshit.sort();

              dayjs.extend(isBetween);
              const checkDate = (check, first, last) => {
                return (
                  dayjs(check).isBetween("2010-01-01", dayjs(), null, "[]") ||
                  dayjs(check).isBetween(first, last, null, "[]")
                );
              };
              const getMin = (array) => {
                return array.reduce((acc, date) => {
                  return acc && new Date(acc) < new Date(date) ? acc : date;
                }, "");
              };
              const getMax = (array) => {
                return array.reduce((acc, date) => {
                  return acc && new Date(acc) > new Date(date) ? acc : date;
                }, "");
              };

              let data = [...blockthisshit, []];
              for (let i = 0; i < data.length; i++) {
                let prev = i === data.length - 1 ? null : data[i - 1];
                let next = i === 0 ? null : data[i + 1];
                let curr = data[i];
                if (
                  prev &&
                  (checkDate(curr[0], prev[0], prev[1]) ||
                    checkDate(curr[1], prev[0], prev[1]))
                ) {
                  let comm = [curr[0], curr[1], prev[0], prev[1]];
                  data[i - 1] = [];
                  data[i] = [getMin(comm), getMax(comm)];
                }
              }
              const ans = data.filter((item) => item.length > 0);

              for (let i = 0; i < disableDates.length; i++) {
                if (
                  new Date(disableDates[i][0]).getTime() <=
                    new Date().getTime() &&
                  new Date(disableDates[i][1]).getTime() >= new Date().getTime()
                ) {
                  ans.push([disableDates[i][0], disableDates[i][1]]);
                }
              }

              for (let i = 0; i < ans.length; i++) {
                if (new Date(ans[i][1]).getTime() < new Date().getTime()) {
                  ans.splice(i, 1);
                }
              }

              ans.sort();
              console.log(ans, "NOWA BLOKADA");
              console.log(disableDates, "DATY W SEZONIE");
              console.log(blockthisshit, "BLOKOWANIE WCZESNIEJ");
              console.log(booked.dates, "ZABLOKOWANE DATY PRZEZ ZAMOWIENIA");

              new Litepicker({
                element: singleContainer,
                lang: language,
                singleMode: false,
                inlineMode: true,
                numberOfMonths: 2,
                numberOfColumns: 2,
                disallowLockDaysInRange: true,
                showTooltip: false,
                startDate: dateStart,
                endDate: dateEnd,
                lockDays: ans,
                minRangelockDays: disableDates,
                plugins: ["mobilefriendly"],
                minDate: new Date(Date.now()),
                minDays: 2,
                hotelType: true,
                setup: (picker) => {
                  var newproductload = {
                    message: "",
                    data: {
                      view: '\n<div class="booking-details__items grid grid-cols-2 md:grid-cols-1 gap-4 items-center">\n\n\t\t<div class="booking-details-item font-bold" data-name="date">\n\t\t<div class="booking-details-item__label uppercase has-1-font-size has-blue-80-color">Wybrany termin</div>\n\t\t<div class="booking-details-item__value has-blue-100-color has-4-font-size">\n\t\t\t<span class="booking-details-item__value-title">Wybierz zakres</span>\n\t\t</div>\n\t</div>\n\n\t\t<div class="booking-details-item font-bold" data-name="total_price">\n\t\t<div class="booking-details-item__label uppercase has-1-font-size has-blue-80-color">\u0141\u0105czny koszt</div>\n\t\t<div class="booking-details-item__value has-blue-100-color has-4-font-size">\n\t\t\t<span class="booking-details-item__value-title"><span class="woocommerce-Price-amount amount"><bdi>0&nbsp;<span class="woocommerce-Price-currencySymbol">&#122;&#322;</span></bdi></span><span class="wceb-price-format"> / night</span></span>\n\t\t</div>\n\t</div>\n\n\t\t<div class="booking-details-item font-bold" data-name="price_per_day">\n\t\t<div class="booking-details-item__label uppercase has-1-font-size has-blue-80-color">Cena za dob\u0119</div>\n\t\t<div class="booking-details-item__value has-blue-100-color has-4-font-size">\n\t\t\t<span class="booking-details-item__value-title">0</span>\n\t\t</div>\n\t</div>\n\n\t\t<div class="booking-details-item font-bold" data-name="total_in_advance">\n\t\t<div class="booking-details-item__label uppercase has-1-font-size has-blue-80-color">Zaliczka</div>\n\t\t<div class="booking-details-item__value has-blue-100-color has-4-font-size">\n\t\t\t<span class="booking-details-item__value-title"></span>\n\t\t</div>\n\t</div>\n\n\t\t<div class="booking-details-item font-bold" data-name="total_rest">\n\t\t<div class="booking-details-item__label uppercase has-1-font-size has-blue-80-color">Reszta do zap\u0142aty</div>\n\t\t<div class="booking-details-item__value has-blue-100-color has-4-font-size">\n\t\t\t<span class="booking-details-item__value-title"></span>\n\t\t</div>\n\t</div>\n\n\n</div>\n',
                      dateStart: null,
                      dateEnd: null,
                    },
                  };
                  this.appendCartFragment(newproductload.data.view);
                  var buttons = document.querySelectorAll(
                    ".button-container > .btn"
                  );
                  buttons.forEach(function (item) {
                    item.setAttribute("disabled", true);
                  });

                  picker.clearSelection();
                  picker.on("before:click", (target: HTMLElement) => {
                    if (
                      !target.classList.contains("cant-start-end") ||
                      !target.dataset.time
                    ) {
                      return;
                    }

                    if (target.classList.contains("is-locked")) {
                      return;
                    }

                    const dateStart = CalendarUtils.getEnabledDateBefore(
                      Litepicker.getDateTimeInstance(target.dataset.time),
                      disableDates,
                      disbaledDatesResponse.dates
                    );
                    const dateEnd = CalendarUtils.getEnabledDateAfter(
                      Litepicker.getDateTimeInstance(target.dataset.time),
                      disableDates,
                      disbaledDatesResponse.dates
                    );
                    picker.clearSelection();
                    for (const value of Object.values(ans)) {
                      if (
                        (new Date(dateStart.dateInstance).getTime() <
                          new Date(value[0]).setHours(0, 0, 0) &&
                          new Date(value[0]).setHours(0, 0, 0) <
                            new Date(dateEnd.dateInstance).getTime()) ||
                        (new Date(dateStart.dateInstance).getTime() <
                          new Date(value[1]).setHours(0, 0, 0) &&
                          new Date(value[1]).setHours(0, 0, 0) <
                            new Date(dateEnd.dateInstance).getTime())
                      ) {
                        picker.clearSelection();
                        return;
                      }
                    }

                    // @ts-expect-error
                    if (dateStart.dateInstance < new Date(Date.now())) {
                      picker.clearSelection();
                      return;
                    } else {
                      picker.setDateRange(dateStart, dateEnd, true);
                    }
                  });
                  picker.on(
                    "selected",
                    (dateStart: DateTime, dateEnd: DateTime) => {
                      const loader = createLoader(
                        document.querySelector(
                          ".booking-details"
                        ) as HTMLElement
                      );
                      bookingContainer.classList.add("is-fetching");

                      this.Cart.addToCart(dateStart, dateEnd).then(() =>
                        this.Cart.getCartFragment().then((cartFragment) => {
                          this.appendCartFragment(cartFragment.data.view);
                          bookingContainer.classList.remove("is-fetching");
                          loader?.remove();
                        })
                      );

                      this.BookingDetails.setActiveButtons();
                    }
                  );
                },
              });
            }
          );
        }
      });
    }
  }

  private setDefaultSettings() {
    const settings = new CalendarSettings();

    this.options = {
      ...this.options,
      language: settings.getLanguage(),
    };
  }

  private appendCartFragment(view: string) {
    const cartFragment = document.querySelector(".cart-fragment");

    if (cartFragment) {
      cartFragment.innerHTML = view;
    }
  }
}
